// Generated from java-escape by ANTLR 4.11.1
// jshint ignore: start
import antlr4 from 'antlr4';
import InsightsQueryListener from './InsightsQueryListener.js';
import InsightsQueryVisitor from './InsightsQueryVisitor.js';

const serializedATN = [4,1,26,103,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,7,
4,2,5,7,5,2,6,7,6,1,0,1,0,1,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,
1,1,1,1,1,1,1,3,1,32,8,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,
1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,
1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,5,1,76,8,1,10,1,12,1,79,
9,1,1,2,1,2,3,2,83,8,2,1,3,1,3,1,3,1,3,1,3,1,4,3,4,91,8,4,1,5,1,5,1,5,5,
5,96,8,5,10,5,12,5,99,9,5,1,6,1,6,1,6,0,1,2,7,0,2,4,6,8,10,12,0,0,118,0,
14,1,0,0,0,2,31,1,0,0,0,4,82,1,0,0,0,6,84,1,0,0,0,8,90,1,0,0,0,10,92,1,0,
0,0,12,100,1,0,0,0,14,15,3,2,1,0,15,16,5,0,0,1,16,1,1,0,0,0,17,18,6,1,-1,
0,18,19,5,1,0,0,19,20,3,2,1,0,20,21,5,2,0,0,21,32,1,0,0,0,22,32,3,6,3,0,
23,32,3,12,6,0,24,32,3,4,2,0,25,26,5,5,0,0,26,32,3,2,1,17,27,28,5,6,0,0,
28,32,3,2,1,16,29,30,5,21,0,0,30,32,3,2,1,15,31,17,1,0,0,0,31,22,1,0,0,0,
31,23,1,0,0,0,31,24,1,0,0,0,31,25,1,0,0,0,31,27,1,0,0,0,31,29,1,0,0,0,32,
77,1,0,0,0,33,34,10,14,0,0,34,35,5,10,0,0,35,76,3,2,1,14,36,37,10,13,0,0,
37,38,5,7,0,0,38,76,3,2,1,14,39,40,10,12,0,0,40,41,5,8,0,0,41,76,3,2,1,13,
42,43,10,11,0,0,43,44,5,5,0,0,44,76,3,2,1,12,45,46,10,10,0,0,46,47,5,6,0,
0,47,76,3,2,1,11,48,49,10,9,0,0,49,50,5,11,0,0,50,76,3,2,1,10,51,52,10,8,
0,0,52,53,5,12,0,0,53,76,3,2,1,9,54,55,10,7,0,0,55,56,5,13,0,0,56,76,3,2,
1,8,57,58,10,6,0,0,58,59,5,14,0,0,59,76,3,2,1,7,60,61,10,5,0,0,61,62,5,15,
0,0,62,76,3,2,1,6,63,64,10,4,0,0,64,65,5,17,0,0,65,76,3,2,1,5,66,67,10,3,
0,0,67,68,5,16,0,0,68,76,3,2,1,4,69,70,10,2,0,0,70,71,5,19,0,0,71,76,3,2,
1,3,72,73,10,1,0,0,73,74,5,20,0,0,74,76,3,2,1,2,75,33,1,0,0,0,75,36,1,0,
0,0,75,39,1,0,0,0,75,42,1,0,0,0,75,45,1,0,0,0,75,48,1,0,0,0,75,51,1,0,0,
0,75,54,1,0,0,0,75,57,1,0,0,0,75,60,1,0,0,0,75,63,1,0,0,0,75,66,1,0,0,0,
75,69,1,0,0,0,75,72,1,0,0,0,76,79,1,0,0,0,77,75,1,0,0,0,77,78,1,0,0,0,78,
3,1,0,0,0,79,77,1,0,0,0,80,83,5,24,0,0,81,83,5,25,0,0,82,80,1,0,0,0,82,81,
1,0,0,0,83,5,1,0,0,0,84,85,5,23,0,0,85,86,5,1,0,0,86,87,3,8,4,0,87,88,5,
2,0,0,88,7,1,0,0,0,89,91,3,10,5,0,90,89,1,0,0,0,90,91,1,0,0,0,91,9,1,0,0,
0,92,97,3,2,1,0,93,94,5,18,0,0,94,96,3,2,1,0,95,93,1,0,0,0,96,99,1,0,0,0,
97,95,1,0,0,0,97,98,1,0,0,0,98,11,1,0,0,0,99,97,1,0,0,0,100,101,5,22,0,0,
101,13,1,0,0,0,6,31,75,77,82,90,97];


const atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

const decisionsToDFA = atn.decisionToState.map( (ds, index) => new antlr4.dfa.DFA(ds, index) );

const sharedContextCache = new antlr4.PredictionContextCache();

export default class InsightsQueryParser extends antlr4.Parser {

    static grammarFileName = "java-escape";
    static literalNames = [ null, "'('", "')'", "'{'", "'}'", "'+'", "'-'", 
                            "'*'", "'/'", "'%'", "'^'", "'&'", "'<'", "'>'", 
                            "'<='", "'>='", null, null, "','" ];
    static symbolicNames = [ null, "LPAREN", "RPAREN", "LBRACE", "RBRACE", 
                             "PLUS", "MINUS", "MUL", "DIV", "MOD", "POW", 
                             "CONCAT", "LT", "GT", "LTE", "GTE", "NEQ", 
                             "EQ", "COMMA", "AND", "OR", "NOT", "ESCAPED_IDENTIFIER", 
                             "UNESCAPED_IDENTIFIER", "NUMBER", "STRING", 
                             "WHITESPACE" ];
    static ruleNames = [ "rootExpression", "expression", "literal", "functionCall", 
                         "callArgs", "values", "identifier" ];

    constructor(input) {
        super(input);
        this._interp = new antlr4.atn.ParserATNSimulator(this, atn, decisionsToDFA, sharedContextCache);
        this.ruleNames = InsightsQueryParser.ruleNames;
        this.literalNames = InsightsQueryParser.literalNames;
        this.symbolicNames = InsightsQueryParser.symbolicNames;
    }

    get atn() {
        return atn;
    }

    sempred(localctx, ruleIndex, predIndex) {
    	switch(ruleIndex) {
    	case 1:
    	    		return this.expression_sempred(localctx, predIndex);
        default:
            throw "No predicate with index:" + ruleIndex;
       }
    }

    expression_sempred(localctx, predIndex) {
    	switch(predIndex) {
    		case 0:
    			return this.precpred(this._ctx, 14);
    		case 1:
    			return this.precpred(this._ctx, 13);
    		case 2:
    			return this.precpred(this._ctx, 12);
    		case 3:
    			return this.precpred(this._ctx, 11);
    		case 4:
    			return this.precpred(this._ctx, 10);
    		case 5:
    			return this.precpred(this._ctx, 9);
    		case 6:
    			return this.precpred(this._ctx, 8);
    		case 7:
    			return this.precpred(this._ctx, 7);
    		case 8:
    			return this.precpred(this._ctx, 6);
    		case 9:
    			return this.precpred(this._ctx, 5);
    		case 10:
    			return this.precpred(this._ctx, 4);
    		case 11:
    			return this.precpred(this._ctx, 3);
    		case 12:
    			return this.precpred(this._ctx, 2);
    		case 13:
    			return this.precpred(this._ctx, 1);
    		default:
    			throw "No predicate with index:" + predIndex;
    	}
    };




	rootExpression() {
	    let localctx = new RootExpressionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 0, InsightsQueryParser.RULE_rootExpression);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 14;
	        this.expression(0);
	        this.state = 15;
	        this.match(InsightsQueryParser.EOF);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}


	expression(_p) {
		if(_p===undefined) {
		    _p = 0;
		}
	    const _parentctx = this._ctx;
	    const _parentState = this.state;
	    let localctx = new ExpressionContext(this, this._ctx, _parentState);
	    let _prevctx = localctx;
	    const _startState = 2;
	    this.enterRecursionRule(localctx, 2, InsightsQueryParser.RULE_expression, _p);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 31;
	        this._errHandler.sync(this);
	        switch(this._input.LA(1)) {
	        case 1:
	            localctx = new ParenthesizedExprContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;

	            this.state = 18;
	            this.match(InsightsQueryParser.LPAREN);
	            this.state = 19;
	            this.expression(0);
	            this.state = 20;
	            this.match(InsightsQueryParser.RPAREN);
	            break;
	        case 23:
	            localctx = new FunctionCallExprContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 22;
	            this.functionCall();
	            break;
	        case 22:
	            localctx = new IdentifierExprContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 23;
	            this.identifier();
	            break;
	        case 24:
	        case 25:
	            localctx = new LiteralExprContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 24;
	            this.literal();
	            break;
	        case 5:
	            localctx = new UnaryPlusExprContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 25;
	            localctx.Operator = this.match(InsightsQueryParser.PLUS);
	            this.state = 26;
	            localctx.Right = this.expression(17);
	            break;
	        case 6:
	            localctx = new UnaryMinusExprContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 27;
	            localctx.Operator = this.match(InsightsQueryParser.MINUS);
	            this.state = 28;
	            localctx.Right = this.expression(16);
	            break;
	        case 21:
	            localctx = new UnaryNotExprContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 29;
	            localctx.Operator = this.match(InsightsQueryParser.NOT);
	            this.state = 30;
	            localctx.Right = this.expression(15);
	            break;
	        default:
	            throw new antlr4.error.NoViableAltException(this);
	        }
	        this._ctx.stop = this._input.LT(-1);
	        this.state = 77;
	        this._errHandler.sync(this);
	        var _alt = this._interp.adaptivePredict(this._input,2,this._ctx)
	        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
	            if(_alt===1) {
	                if(this._parseListeners!==null) {
	                    this.triggerExitRuleEvent();
	                }
	                _prevctx = localctx;
	                this.state = 75;
	                this._errHandler.sync(this);
	                var la_ = this._interp.adaptivePredict(this._input,1,this._ctx);
	                switch(la_) {
	                case 1:
	                    localctx = new RaiseToExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, InsightsQueryParser.RULE_expression);
	                    this.state = 33;
	                    if (!( this.precpred(this._ctx, 14))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 14)");
	                    }
	                    this.state = 34;
	                    localctx.Operator = this.match(InsightsQueryParser.POW);
	                    this.state = 35;
	                    localctx.Right = this.expression(14);
	                    break;

	                case 2:
	                    localctx = new MultiplyExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, InsightsQueryParser.RULE_expression);
	                    this.state = 36;
	                    if (!( this.precpred(this._ctx, 13))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 13)");
	                    }
	                    this.state = 37;
	                    localctx.Operator = this.match(InsightsQueryParser.MUL);
	                    this.state = 38;
	                    localctx.Right = this.expression(14);
	                    break;

	                case 3:
	                    localctx = new DivideExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, InsightsQueryParser.RULE_expression);
	                    this.state = 39;
	                    if (!( this.precpred(this._ctx, 12))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 12)");
	                    }
	                    this.state = 40;
	                    localctx.Operator = this.match(InsightsQueryParser.DIV);
	                    this.state = 41;
	                    localctx.Right = this.expression(13);
	                    break;

	                case 4:
	                    localctx = new AddExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, InsightsQueryParser.RULE_expression);
	                    this.state = 42;
	                    if (!( this.precpred(this._ctx, 11))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 11)");
	                    }
	                    this.state = 43;
	                    localctx.Operator = this.match(InsightsQueryParser.PLUS);
	                    this.state = 44;
	                    localctx.Right = this.expression(12);
	                    break;

	                case 5:
	                    localctx = new SubtractExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, InsightsQueryParser.RULE_expression);
	                    this.state = 45;
	                    if (!( this.precpred(this._ctx, 10))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 10)");
	                    }
	                    this.state = 46;
	                    localctx.Operator = this.match(InsightsQueryParser.MINUS);
	                    this.state = 47;
	                    localctx.Right = this.expression(11);
	                    break;

	                case 6:
	                    localctx = new ConcatExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, InsightsQueryParser.RULE_expression);
	                    this.state = 48;
	                    if (!( this.precpred(this._ctx, 9))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 9)");
	                    }
	                    this.state = 49;
	                    localctx.Operator = this.match(InsightsQueryParser.CONCAT);
	                    this.state = 50;
	                    localctx.Right = this.expression(10);
	                    break;

	                case 7:
	                    localctx = new LessThanExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, InsightsQueryParser.RULE_expression);
	                    this.state = 51;
	                    if (!( this.precpred(this._ctx, 8))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 8)");
	                    }
	                    this.state = 52;
	                    localctx.Operator = this.match(InsightsQueryParser.LT);
	                    this.state = 53;
	                    localctx.Right = this.expression(9);
	                    break;

	                case 8:
	                    localctx = new GreaterThanExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, InsightsQueryParser.RULE_expression);
	                    this.state = 54;
	                    if (!( this.precpred(this._ctx, 7))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 7)");
	                    }
	                    this.state = 55;
	                    localctx.Operator = this.match(InsightsQueryParser.GT);
	                    this.state = 56;
	                    localctx.Right = this.expression(8);
	                    break;

	                case 9:
	                    localctx = new LessThanOrEqualExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, InsightsQueryParser.RULE_expression);
	                    this.state = 57;
	                    if (!( this.precpred(this._ctx, 6))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 6)");
	                    }
	                    this.state = 58;
	                    localctx.Operator = this.match(InsightsQueryParser.LTE);
	                    this.state = 59;
	                    localctx.Right = this.expression(7);
	                    break;

	                case 10:
	                    localctx = new GreaterThanOrEqualExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, InsightsQueryParser.RULE_expression);
	                    this.state = 60;
	                    if (!( this.precpred(this._ctx, 5))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 5)");
	                    }
	                    this.state = 61;
	                    localctx.Operator = this.match(InsightsQueryParser.GTE);
	                    this.state = 62;
	                    localctx.Right = this.expression(6);
	                    break;

	                case 11:
	                    localctx = new EqualExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, InsightsQueryParser.RULE_expression);
	                    this.state = 63;
	                    if (!( this.precpred(this._ctx, 4))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 4)");
	                    }
	                    this.state = 64;
	                    localctx.Operator = this.match(InsightsQueryParser.EQ);
	                    this.state = 65;
	                    localctx.Right = this.expression(5);
	                    break;

	                case 12:
	                    localctx = new NotEqualExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, InsightsQueryParser.RULE_expression);
	                    this.state = 66;
	                    if (!( this.precpred(this._ctx, 3))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 3)");
	                    }
	                    this.state = 67;
	                    localctx.Operator = this.match(InsightsQueryParser.NEQ);
	                    this.state = 68;
	                    localctx.Right = this.expression(4);
	                    break;

	                case 13:
	                    localctx = new AndExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, InsightsQueryParser.RULE_expression);
	                    this.state = 69;
	                    if (!( this.precpred(this._ctx, 2))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 2)");
	                    }
	                    this.state = 70;
	                    localctx.Operator = this.match(InsightsQueryParser.AND);
	                    this.state = 71;
	                    localctx.Right = this.expression(3);
	                    break;

	                case 14:
	                    localctx = new OrExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, InsightsQueryParser.RULE_expression);
	                    this.state = 72;
	                    if (!( this.precpred(this._ctx, 1))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 1)");
	                    }
	                    this.state = 73;
	                    localctx.Operator = this.match(InsightsQueryParser.OR);
	                    this.state = 74;
	                    localctx.Right = this.expression(2);
	                    break;

	                } 
	            }
	            this.state = 79;
	            this._errHandler.sync(this);
	            _alt = this._interp.adaptivePredict(this._input,2,this._ctx);
	        }

	    } catch( error) {
	        if(error instanceof antlr4.error.RecognitionException) {
		        localctx.exception = error;
		        this._errHandler.reportError(this, error);
		        this._errHandler.recover(this, error);
		    } else {
		    	throw error;
		    }
	    } finally {
	        this.unrollRecursionContexts(_parentctx)
	    }
	    return localctx;
	}



	literal() {
	    let localctx = new LiteralContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 4, InsightsQueryParser.RULE_literal);
	    try {
	        this.state = 82;
	        this._errHandler.sync(this);
	        switch(this._input.LA(1)) {
	        case 24:
	            localctx = new NumberLiteralContext(this, localctx);
	            this.enterOuterAlt(localctx, 1);
	            this.state = 80;
	            this.match(InsightsQueryParser.NUMBER);
	            break;
	        case 25:
	            localctx = new StringLiteralContext(this, localctx);
	            this.enterOuterAlt(localctx, 2);
	            this.state = 81;
	            this.match(InsightsQueryParser.STRING);
	            break;
	        default:
	            throw new antlr4.error.NoViableAltException(this);
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	functionCall() {
	    let localctx = new FunctionCallContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 6, InsightsQueryParser.RULE_functionCall);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 84;
	        this.match(InsightsQueryParser.UNESCAPED_IDENTIFIER);
	        this.state = 85;
	        this.match(InsightsQueryParser.LPAREN);
	        this.state = 86;
	        this.callArgs();
	        this.state = 87;
	        this.match(InsightsQueryParser.RPAREN);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	callArgs() {
	    let localctx = new CallArgsContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 8, InsightsQueryParser.RULE_callArgs);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 90;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if((((_la) & ~0x1f) == 0 && ((1 << _la) & 65011810) !== 0)) {
	            this.state = 89;
	            this.values();
	        }

	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	values() {
	    let localctx = new ValuesContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 10, InsightsQueryParser.RULE_values);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 92;
	        this.expression(0);
	        this.state = 97;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        while(_la===18) {
	            this.state = 93;
	            this.match(InsightsQueryParser.COMMA);
	            this.state = 94;
	            this.expression(0);
	            this.state = 99;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	identifier() {
	    let localctx = new IdentifierContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 12, InsightsQueryParser.RULE_identifier);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 100;
	        this.match(InsightsQueryParser.ESCAPED_IDENTIFIER);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}


}

InsightsQueryParser.EOF = antlr4.Token.EOF;
InsightsQueryParser.LPAREN = 1;
InsightsQueryParser.RPAREN = 2;
InsightsQueryParser.LBRACE = 3;
InsightsQueryParser.RBRACE = 4;
InsightsQueryParser.PLUS = 5;
InsightsQueryParser.MINUS = 6;
InsightsQueryParser.MUL = 7;
InsightsQueryParser.DIV = 8;
InsightsQueryParser.MOD = 9;
InsightsQueryParser.POW = 10;
InsightsQueryParser.CONCAT = 11;
InsightsQueryParser.LT = 12;
InsightsQueryParser.GT = 13;
InsightsQueryParser.LTE = 14;
InsightsQueryParser.GTE = 15;
InsightsQueryParser.NEQ = 16;
InsightsQueryParser.EQ = 17;
InsightsQueryParser.COMMA = 18;
InsightsQueryParser.AND = 19;
InsightsQueryParser.OR = 20;
InsightsQueryParser.NOT = 21;
InsightsQueryParser.ESCAPED_IDENTIFIER = 22;
InsightsQueryParser.UNESCAPED_IDENTIFIER = 23;
InsightsQueryParser.NUMBER = 24;
InsightsQueryParser.STRING = 25;
InsightsQueryParser.WHITESPACE = 26;

InsightsQueryParser.RULE_rootExpression = 0;
InsightsQueryParser.RULE_expression = 1;
InsightsQueryParser.RULE_literal = 2;
InsightsQueryParser.RULE_functionCall = 3;
InsightsQueryParser.RULE_callArgs = 4;
InsightsQueryParser.RULE_values = 5;
InsightsQueryParser.RULE_identifier = 6;

class RootExpressionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = InsightsQueryParser.RULE_rootExpression;
    }

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	EOF() {
	    return this.getToken(InsightsQueryParser.EOF, 0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterRootExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitRootExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitRootExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ExpressionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = InsightsQueryParser.RULE_expression;
    }


	 
		copyFrom(ctx) {
			super.copyFrom(ctx);
		}

}


class AndExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	AND() {
	    return this.getToken(InsightsQueryParser.AND, 0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterAndExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitAndExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitAndExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

InsightsQueryParser.AndExprContext = AndExprContext;

class EqualExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	EQ() {
	    return this.getToken(InsightsQueryParser.EQ, 0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterEqualExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitEqualExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitEqualExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

InsightsQueryParser.EqualExprContext = EqualExprContext;

class GreaterThanExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	GT() {
	    return this.getToken(InsightsQueryParser.GT, 0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterGreaterThanExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitGreaterThanExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitGreaterThanExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

InsightsQueryParser.GreaterThanExprContext = GreaterThanExprContext;

class MultiplyExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	MUL() {
	    return this.getToken(InsightsQueryParser.MUL, 0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterMultiplyExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitMultiplyExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitMultiplyExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

InsightsQueryParser.MultiplyExprContext = MultiplyExprContext;

class UnaryNotExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	NOT() {
	    return this.getToken(InsightsQueryParser.NOT, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterUnaryNotExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitUnaryNotExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitUnaryNotExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

InsightsQueryParser.UnaryNotExprContext = UnaryNotExprContext;

class AddExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	PLUS() {
	    return this.getToken(InsightsQueryParser.PLUS, 0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterAddExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitAddExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitAddExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

InsightsQueryParser.AddExprContext = AddExprContext;

class RaiseToExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	POW() {
	    return this.getToken(InsightsQueryParser.POW, 0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterRaiseToExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitRaiseToExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitRaiseToExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

InsightsQueryParser.RaiseToExprContext = RaiseToExprContext;

class NotEqualExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	NEQ() {
	    return this.getToken(InsightsQueryParser.NEQ, 0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterNotEqualExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitNotEqualExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitNotEqualExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

InsightsQueryParser.NotEqualExprContext = NotEqualExprContext;

class OrExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	OR() {
	    return this.getToken(InsightsQueryParser.OR, 0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterOrExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitOrExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitOrExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

InsightsQueryParser.OrExprContext = OrExprContext;

class DivideExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	DIV() {
	    return this.getToken(InsightsQueryParser.DIV, 0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterDivideExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitDivideExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitDivideExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

InsightsQueryParser.DivideExprContext = DivideExprContext;

class LessThanOrEqualExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	LTE() {
	    return this.getToken(InsightsQueryParser.LTE, 0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterLessThanOrEqualExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitLessThanOrEqualExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitLessThanOrEqualExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

InsightsQueryParser.LessThanOrEqualExprContext = LessThanOrEqualExprContext;

class ConcatExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	CONCAT() {
	    return this.getToken(InsightsQueryParser.CONCAT, 0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterConcatExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitConcatExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitConcatExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

InsightsQueryParser.ConcatExprContext = ConcatExprContext;

class FunctionCallExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	functionCall() {
	    return this.getTypedRuleContext(FunctionCallContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterFunctionCallExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitFunctionCallExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitFunctionCallExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

InsightsQueryParser.FunctionCallExprContext = FunctionCallExprContext;

class IdentifierExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	identifier() {
	    return this.getTypedRuleContext(IdentifierContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterIdentifierExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitIdentifierExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitIdentifierExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

InsightsQueryParser.IdentifierExprContext = IdentifierExprContext;

class UnaryPlusExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	PLUS() {
	    return this.getToken(InsightsQueryParser.PLUS, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterUnaryPlusExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitUnaryPlusExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitUnaryPlusExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

InsightsQueryParser.UnaryPlusExprContext = UnaryPlusExprContext;

class LiteralExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	literal() {
	    return this.getTypedRuleContext(LiteralContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterLiteralExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitLiteralExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitLiteralExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

InsightsQueryParser.LiteralExprContext = LiteralExprContext;

class ParenthesizedExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	LPAREN() {
	    return this.getToken(InsightsQueryParser.LPAREN, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	RPAREN() {
	    return this.getToken(InsightsQueryParser.RPAREN, 0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterParenthesizedExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitParenthesizedExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitParenthesizedExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

InsightsQueryParser.ParenthesizedExprContext = ParenthesizedExprContext;

class SubtractExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	MINUS() {
	    return this.getToken(InsightsQueryParser.MINUS, 0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterSubtractExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitSubtractExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitSubtractExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

InsightsQueryParser.SubtractExprContext = SubtractExprContext;

class LessThanExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	LT() {
	    return this.getToken(InsightsQueryParser.LT, 0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterLessThanExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitLessThanExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitLessThanExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

InsightsQueryParser.LessThanExprContext = LessThanExprContext;

class UnaryMinusExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	MINUS() {
	    return this.getToken(InsightsQueryParser.MINUS, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterUnaryMinusExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitUnaryMinusExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitUnaryMinusExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

InsightsQueryParser.UnaryMinusExprContext = UnaryMinusExprContext;

class GreaterThanOrEqualExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	GTE() {
	    return this.getToken(InsightsQueryParser.GTE, 0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterGreaterThanOrEqualExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitGreaterThanOrEqualExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitGreaterThanOrEqualExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

InsightsQueryParser.GreaterThanOrEqualExprContext = GreaterThanOrEqualExprContext;

class LiteralContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = InsightsQueryParser.RULE_literal;
    }


	 
		copyFrom(ctx) {
			super.copyFrom(ctx);
		}

}


class StringLiteralContext extends LiteralContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	STRING() {
	    return this.getToken(InsightsQueryParser.STRING, 0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterStringLiteral(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitStringLiteral(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitStringLiteral(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

InsightsQueryParser.StringLiteralContext = StringLiteralContext;

class NumberLiteralContext extends LiteralContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	NUMBER() {
	    return this.getToken(InsightsQueryParser.NUMBER, 0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterNumberLiteral(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitNumberLiteral(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitNumberLiteral(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

InsightsQueryParser.NumberLiteralContext = NumberLiteralContext;

class FunctionCallContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = InsightsQueryParser.RULE_functionCall;
    }

	UNESCAPED_IDENTIFIER() {
	    return this.getToken(InsightsQueryParser.UNESCAPED_IDENTIFIER, 0);
	};

	LPAREN() {
	    return this.getToken(InsightsQueryParser.LPAREN, 0);
	};

	callArgs() {
	    return this.getTypedRuleContext(CallArgsContext,0);
	};

	RPAREN() {
	    return this.getToken(InsightsQueryParser.RPAREN, 0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterFunctionCall(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitFunctionCall(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitFunctionCall(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class CallArgsContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = InsightsQueryParser.RULE_callArgs;
    }

	values() {
	    return this.getTypedRuleContext(ValuesContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterCallArgs(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitCallArgs(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitCallArgs(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ValuesContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = InsightsQueryParser.RULE_values;
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	COMMA = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(InsightsQueryParser.COMMA);
	    } else {
	        return this.getToken(InsightsQueryParser.COMMA, i);
	    }
	};


	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterValues(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitValues(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitValues(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class IdentifierContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = InsightsQueryParser.RULE_identifier;
    }

	ESCAPED_IDENTIFIER() {
	    return this.getToken(InsightsQueryParser.ESCAPED_IDENTIFIER, 0);
	};

	enterRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.enterIdentifier(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof InsightsQueryListener ) {
	        listener.exitIdentifier(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof InsightsQueryVisitor ) {
	        return visitor.visitIdentifier(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}




InsightsQueryParser.RootExpressionContext = RootExpressionContext; 
InsightsQueryParser.ExpressionContext = ExpressionContext; 
InsightsQueryParser.LiteralContext = LiteralContext; 
InsightsQueryParser.FunctionCallContext = FunctionCallContext; 
InsightsQueryParser.CallArgsContext = CallArgsContext; 
InsightsQueryParser.ValuesContext = ValuesContext; 
InsightsQueryParser.IdentifierContext = IdentifierContext; 
